import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import arrow from "../../assets/icons/arrow_down.svg";
import nft_placeholder from "../../assets/placeholder/placeholder_large.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { MOBILE } from "../../constants/breakpoints";

const ImageSection = (props: any) => {
  const [nftData, setNftData] = useState<any>({});
  const [showFullDescription, setShowFullDescription] = useState(false);

  const wallet = useSelector((state: RootState) => state.walletState);
  const navigate = useNavigate();

  useEffect(() => {
    if (props?.nftMetadata) {
      setNftData(JSON.parse(props?.nftMetadata.metadata));
    }
  }, [props?.nftMetadata]);

  const handleBackClick = () => {
    navigate(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
  };

  return (
    <>
      {nftData && nftData.image ? (
        <div>
          {props?.isVerify
            ? <></>
            : (
              <span
                css={css`
              display: flex;
              cursor: pointer;
              transition: all 0.2s ease-in-out;
            `}
                onClick={handleBackClick}
              >
                <img
                  css={css`
                transform: rotate(90deg);
                filter: brightness(-100%);
              `}
                  src={arrow}
                  alt=""
                />
                <p
                  css={css`
                margin-left: 13.5px;
                font-weight: 700;
                font-size: 16px;

                @media (max-width: ${MOBILE}px) {
                  font-size: 14px;
                }
              `}
                >
                  List of Assets
                </p>
              </span>
            )
          }
          <div
            css={css`
              @media (max-width: ${MOBILE}px) {
                display: flex;
                justify-content: space-between;
              }
            `}
          >
            <span
              css={css`
                @media (max-width: ${MOBILE}px) {
                  width: 60%;
                }
              `}
            >
              <h1
                css={css`
                  font-size: 24px;
                  font-weight: 700;
                  @media (max-width: ${MOBILE}px) {
                    font-size: 24px;
                  }
                `}
              >
                {nftData.name || `${props?.nftMetadata?.name} #${props?.nftMetadata?.token_id}`}
              </h1>
              {/* <h3
                css={css`
                  font-weight: 700;
                  font-size: 16px;
                  margin: 0;
                `}
              >
                By DeLabs
              </h3> */}
              {
                nftData.description
                  ? (
                    <div
                      css={css`
                  font-weight: 500;
                  font-size: 16px;
                  margin: 0;
                  margin-top: 5px;
                  @media (max-width: ${MOBILE}px) {
                    font-size: 14px;
                  }
                `}
                    >
                      {showFullDescription
                        ? nftData.description
                        : (nftData?.description?.slice(0, 40) + (nftData?.description?.length > 40 ? '...' : ''))
                      }
                      <span
                        css={css`
                    color: #757272;
                    cursor: pointer;
                  `}
                        onClick={() => setShowFullDescription(!showFullDescription)}
                      >
                        {showFullDescription ? " View Less" : " View More"}
                      </span>
                    </div>
                  )
                  : <span
                    css={css`
                      color: #757272;
                      cursor: pointer;
                      padding-top: 5px;
                    `}
                  >No Description</span>
              }

            </span>

            <img
              css={css`
                width: 580px;
                object-fit: cover;
                border: 1px solid #ccc4b3;
                border-radius: 24px;
                margin-top: 40px;

                @media (max-width: ${MOBILE}px) {
                  width: 106px;
                  height: 135.497px;
                }
              `}
              src={nftData?.image?.includes('ipfs://') ? `https://cf-ipfs.com/ipfs/${nftData?.image?.split('://')[1]}` : nftData?.image}
              alt=""
              loading="lazy"
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ImageSection;
